<template>
    <section>
    <joinCampaignModal></JoinCampaignModal>
    <CreateCampaignModal></CreateCampaignModal>
    <CampaignDetailsModal
        :campaign="campaignDetails"
    ></CampaignDetailsModal>
    <LeaveCampaignModal
        :campaign="campaignDetails"
    ></LeaveCampaignModal>
    <InstallHomescreenModal>
    </InstallHomescreenModal>
    <InstallIosModal>
    </InstallIosModal>
    <Header 
    ref="campaignsListHeader"
    :header_page_data="headerPageData"
    ></Header>
      <section>
        <div class="container container-app">
            <section class="position-relative campaigns-container mt-4">
                <div class="col-12 mb-3 pr-0 pl-0">
                    <div class="input-group">
                        <input @input="clearOnEmpty()" @keyup.enter="search()" :placeholder="$t('campaign_list.search')" type="text" class="form-control--canvassing border-bottom cancassing-search" v-model="searchText">
                        <span class="cursor-pointer" @click.prevent="search()"><img class="search-icon-grey" src="./../../assets/search_grey.svg" alt="search" /></span>
                    </div>
                </div>
                <div class="campaigns-scroll-container">
                    <span class="no-results-found-label" v-if="campaignsListComputed.length == 0">{{ $t('campaign_list.no_results_found') }}</span>
                    <div v-for="(campaign, index) in campaignsListComputed" :key="index" class="row mb-2">
                        <div class="col-2">
                            <div @click.prevent="goAndAdd('campaign-map', {campaign_id: campaign._id, campaign: campaign})" class="round-campaign-name cursor-pointer" :style="'background: ' + listDesignColor[calculateColorListing(index)].background + ';  border: 2px solid #ffffff; box-shadow: 0 0 0 2px ' + listDesignColor[calculateColorListing(index)].border + ';'"><span :style="'color: ' + listDesignColor[calculateColorListing(index)].color + ';'">{{ campaign.name.substring(0,1).toUpperCase() }}</span></div>
                        </div>
                        <div  class="col-5 pl-0" :class="{'mt-2': !isOwner(campaign.owner_id), 'mt-3': isOwner(campaign.owner_id)}">
                            <div @click.prevent="goAndAdd('campaign-map', {campaign_id: campaign._id, campaign: campaign})" class="campaign-name ml-3 float-left cursor-pointer">{{ campaign.name }}</div>
                            <div v-if="!isOwner(campaign.owner_id)" class="campaign-by-label ml-3 float-left">{{ $t('campaign_list.by') }} {{ campaign.owner_name }}</div>
                        </div>
                        <div  class="col-5 mt-2">
                            <img @click.prevent="showCampaignDetails(campaign)" data-toggle="modal" data-target="#campaignDetailsModal" class="float-right info-icon mr-3 cursor-pointer" src="./../../assets/info.svg" alt="info" />
                            <div v-if="campaignStatus(campaign) != ''" class="campaign-status float-right mr-2" :class="campaignStatus(campaign)">{{ $t('campaign_teams.status.'+campaignStatus(campaign)) }}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="hr"></div>
                        <button @click="showModalJoin" class="btn shadow btn-app btn-block mb-3 mt-5 primaryBackground">{{ $t('campaign_list.join_as_volunteer') }}</button>
                        <div class="or w-100 text-center mb-3"> {{ $t('campaign_list.or') }} </div>
                        <div @click="showModalCreate" class="create-campaign-button w-100 text-center cursor-pointer">{{ $t('campaign_list.create_campaign') }}</div>
                    </div>
                </div>
            </section>
        </div>
      </section>
    </section>
</template>

<script>
    import Header from "../layouts/Header";
    import CreateCampaignModal from "../modals/CreateCampaignModal";
    import JoinCampaignModal from "../modals/JoinCampaignModal";
    import CampaignDetailsModal from "../modals/CampaignDetailsModal";
    import LeaveCampaignModal from "../modals/LeaveCampaignModal";
    import InstallHomescreenModal from "../modals/InstallHomescreenModal";
    import InstallIosModal from "../modals/InstallIosModal";
    
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "CampaignList",
        components: {
            Header, JoinCampaignModal, CreateCampaignModal, 
            CampaignDetailsModal, LeaveCampaignModal, 
            InstallHomescreenModal, InstallIosModal
        },
        mixins: [HelperMixin],
        data() {
            return {
                searchText: '',
                campaignDetails: {
                    name: 'Name',
                    status: 'pending',
                    owner: 'Stefan'
                },
                headerPageData: {
                    title: this.$t('campaign_list.title'),
                    search: {
                        show: false,
                        type_search: 'campaigns'
                    },
                    settings: {
                        show: false,
                    },
                    home: {
                        show: false,
                    },
                    profile: {
                        show: true
                    }
                }
            }
        },
        created() {
            this.refreshDashboardData();
        },
        computed: {
            campaignsListComputed() {
                return this.$store.getters["campaignsList"];
            }
        },
        methods: {
            showModalCreate() {
                if (!this.$store.getters['online']) {
                    $('#featureUnavailableOfflineModal').modal('show');
                    return false;
                }
                $('#createCampaignModal').modal('show');
            },

            showModalJoin() {
                if (!this.$store.getters['online']) {
                    $('#featureUnavailableOfflineModal').modal('show');
                    return false;
                }
                $('#joinCampaignModal').modal('show');
            },

            clearOnEmpty() {
                if (this.searchText == '') {
                    if (!this.$store.getters['online']) {
                        return false;
                    }
                    this.$refs.campaignsListHeader.form.text = this.searchText;
                    this.$refs.campaignsListHeader.search('campaigns');
                }
            },

            search(campaignsListHeader) {
                if (!this.$store.getters['online']) {
                    $('#featureUnavailableOfflineModal').modal('show');
                    this.searchText = '';
                    return false;
                }
                this.$refs.campaignsListHeader.form.text = this.searchText;
                this.$refs.campaignsListHeader.search('campaigns');
            },

            campaignStatus(campaign) {
                if (campaign.status == 'inactive') {
                    return campaign.status;
                }
                if (this.isOwner(campaign.owner_id)) {
                    return '';
                } 

                if (campaign.user_status == 'active') {
                    return '';
                }

                return campaign.user_status;
            },
            
            goAndAdd(page, params) {
                if (typeof params.campaign != 'undefined') {
                    this.$store.dispatch('saveCurrentCampaign', {
                        currentCampaign: params.campaign
                    });
                    if (
                        (params.campaign.status == 'inactive' && !this.isOwner(params.campaign.owner_id)) ||
                        params.campaign.user_status == 'pending' ||
                        params.campaign.user_status == 'denied'
                        ) {
                        return false;
                    }
                    
                    this.goto(page, params);
                }
            },

            showCampaignDetails(campaign) {
                this.campaignDetails = campaign;
            },

            getCampaignsList() {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            refreshDashboardData() {
                if (this.$store.getters["user"] === null) {
                    if (typeof this.$store.getters["token"] == 'undefined') {
                         this.$router.replace({ name: "login"});
                         return false;
                    }
                }
                this.refreshData();
            }
        },
    };
</script>
